import React, { useEffect, useState } from 'react'
import { Localvalue } from '../nametitle/localValue';
import { LoadAllTemoignage, LoadAllTemoignageId } from '../actions/Temoignages/TemoignageAction';
import { isEmptyArray } from 'formik';
import ReactPlayer from 'react-player';
import AllRoutes from '../nametitle/AllRoutes';
import { CreateEmail } from '../actions/Emails/EmailsAction';
import { CreateComment, LoadAllComment, LoadAllCommentSubjectId } from '../actions/Comments/CommentAction';
import { getDataFromFile } from '../actions/SearchAction';
import { useParams } from 'react-router-dom';

const DetailActivity = () => {
    var id = localStorage.getItem(Localvalue.idTemoignage)
    const params =  useParams();



    const [emailsend, setemailsend] = useState("");
    const [Temoignage, setTemoignage] = useState([]);
    const [commentList, setcommentList] = useState([]);

    const [title, settitle] = useState();
    const [coverPicture, setcoverPicture] = useState();
    const [description, setdescription] = useState();
    const [content, setcontent] = useState();
    const [video, setvideo] = useState();
    const [audio, setaudio] = useState();

    //Comment
    const [typecomment, settypecomment] = useState("temoignage");
    const [commentSubject, setcommentSubject] = useState("");

    useEffect(() => {

        if (params && params.id) {
            const myList = getDataFromFile(Localvalue.temoignagesData);
            const myObject = myList.find(item => item._id === params.id);
            settitle(myObject && myObject.title ? myObject.title : "");
            setcoverPicture(myObject && myObject.coverPicture ? myObject.coverPicture : "");
            setcontent(myObject && myObject.content ? myObject.content : "");
            setaudio(myObject && myObject.audio ? myObject.audio : "");
            setdescription(myObject && myObject.description ? myObject.description : "");

            LoadAllTemoignageId(id, settitle, setcoverPicture, setcontent, setvideo, setaudio, setdescription);
            console.log(Temoignage.video);
            LoadAllCommentSubjectId(id, setcommentList);
        } else {
            LoadAllTemoignageId(id, settitle, setcoverPicture, setcontent, setvideo, setaudio, setdescription);
            console.log(Temoignage.video);
            LoadAllCommentSubjectId(id, setcommentList);
        }

    }, []);

    return (
        <div>
            <div className="container py-5">
                <div className="row g-5">
                    <div className="col-lg-8">

                        <div className="mb-5">
                            <img className="img-fluid w-100 rounded mb-5" src={coverPicture} alt="" />
                            <h1 className="text-uppercase mb-4 text-4xl translatable">{title}</h1>
                            {
                                //<p>{description}</p>
                                /**
                                 * <div className="py-5">
                                <ReactPlayer className="w-[100%] h-[30%]"
                                    url={`${video}`} controls loop config={true}
                                    height={"30%"}
                                    width={"100%"}
                                />
                            </div>
                                 */
                            }
                            <div className="w-full translatable" dangerouslySetInnerHTML={{ __html: content }}></div>
                        </div>

                        <div className="bg-light rounded p-5">
                            <h3 className="text-uppercase border-start border-5 border-primary ps-3 mb-4 translatable">Votre avis compte</h3>
                            <form onSubmit={(e) => {
                                e.preventDefault();
                                CreateComment(id, title, commentSubject, typecomment, coverPicture);
                            }}>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <textarea value={commentSubject} onChange={(e) => { setcommentSubject(e.target.value) }} className="form-control bg-white border-0 translatable" rows="5" placeholder="Comment"></textarea>
                                    </div>
                                    <div className="col-12">
                                        <button className="btn btn-primary bg-lime-600 w-100 py-3 translatable" type="submit">Poster votre commentaire</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="mb-5">
                            <h3 className="text-uppercase border-start border-5 border-primary ps-3 mb-4">{commentList.length} <span className="translatable">Comments</span></h3>
                            {
                                commentList.map((item) => {
                                    return (
                                        <div className="d-flex mb-4">
                                            <img src={`${item.person.coverPicture}`} className="img-fluid" style={{ width: "45px", height: "45px" }} />
                                            <div className="ps-3">
                                                <h6><a href=""></a> <small><i></i></small></h6>
                                                <p className="bg-lime-700 text-white py-3 px-2 rounded-lg translatable">{item.content}</p>
                                                {//<button className="btn btn-sm btn-light">Reply</button>
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="w-full mb-5">
                            <div className="d-flex overflow-hidden mb-3">
                                <img className="img-fluid" src={coverPicture} style={{ width: "100px", height: "100px", objectFit: "cover" }} alt="" />
                                <a href="" className="h5 d-flex align-items-center bg-light px-3 mb-0 translatable"
                                >{title}
                                </a>
                            </div>
                        </div>




                        <div>
                            <div className="bg-light text-center" style={{ padding: "30px" }}>
                                <p className="translatable">{description}</p>
                                <a href={`/${AllRoutes.temoignage}`} className="btn btn-primary py-2 px-4 translatable">voire plus de temoigages comme ceci</a>
                            </div>
                        </div>

                        <div>
                            <form className="relative"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    CreateEmail(emailsend)
                                }}
                            >
                                <div className="bg-light text-center  " style={{ padding: "30px" }}>
                                    <p className="text-left text-lg translatable">Envoyer votre email </p>
                                    <div className="flex">
                                        <input type="email" value={emailsend} onChange={(e) => { setemailsend(e.target.value) }} className="form-control bg-white border-0 px-4 py-2 visible translatable" placeholder="titre" />
                                        <button type="submit" className="btn bg-lime-500  py-2 px-4 translatable">Envoyer </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>

                </div>
            </div>

        </div>
    )
}

export default DetailActivity;